import * as React from "react";
import { Icon } from "azure-devops-ui/Icon";

export default class IconExample extends React.Component {
    public render(): JSX.Element {
        return <Icon ariaLabel="Video icon" iconName="Video" />;
    }
}
